import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Grid} from "@material-ui/core";
import { absorbEvent } from '../utilities/Utilities';

class PopUp extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            productIDA: 0,
            productIDB: 0,
            direction: 0,
            animationStatus: 0,
            disabled: true,
            start: -1
        }

        this.productID = 0;

        this.productImage = new Image();
        this.productsA = new Image();
        this.productsController = new Image();
        this.mainPopUpDiv = undefined;
        this.enableNavigate = true;

        this.navigateToPreviousProduct = this
            .navigateToPreviousProduct
            .bind(this);

        this.navigateToNextProduct = this
            .navigateToNextProduct
            .bind(this);

        this.getProductNavigation = this
            .getProductNavigation
            .bind(this);

        this.getPreviousProduct = this
            .getPreviousProduct
            .bind(this);

        this.getNextProduct = this
            .getNextProduct
            .bind(this);

        this.enable = this
            .enable
            .bind(this);

        this.disable = this
            .disable
            .bind(this);
    }

    componentDidMount()
    {
        this.productImage = document.getElementById("all_products");
        this.mainPopUpDiv = document.getElementById("pop_up_main");
        this.productImage.onanimationend = () => {
            this.enableNavigate = true;};

        this.productsController = document.getElementById("product_controller");

        this.productsController.onanimationend = () => {
            this.enableNavigate = true;
        };
    }

    componentDidUpdate()
    {}

    getPopUpState(enterTerm, exitTerm, disableTerm)
    {
        switch (this.state.start) {
            default:
            case - 1:
                return disableTerm;
            case 0:
                return exitTerm;
            case 1:
                return enterTerm;
        }
    }

    getPreviousProduct()
    {
        return Math.max(this.productID - 1, 0);
    }

    getNextProduct()
    {
        return Math.min(this.productID + 1, this.props.images.length - 1);
    }

    navigateToPreviousProduct()
    {
        if (this.productID !== 0) {
            // this.enableNavigate = this.props.performanceMode ? true : false;
            this.productID = this.getPreviousProduct();
            this.setState({
                direction: -1,
                productIDA: this.getNextProduct(),
                productIDB: this.productID
            });
        }
    }

    navigateToNextProduct()
    {
        if (!(this.productID + 1 >= this.props.images.length)) {
            // this.enableNavigate = this.props.performanceMode ? true : false;
            this.productID = this.getNextProduct();
            this.setState({
                direction: 1,
                productIDA: this.getPreviousProduct(),
                productIDB: this.productID
            });
        }
    }

    enable()
    {
        this.productID = 0;
        this.productImage.onanimationend = () => {};
        this.setState({disabled: false, start: 1})
    }

    disable()
    {
        this
            .props
            .closePopUpFunc();
        this.setState({start: 0})
        this.productImage.onanimationend = () => {
            // this.props.removePopUpFunc();
            this.productID = 0;
            this.setState({disabled: true, productIDA: 0, productIDB: 0, direction: 0})
        };
    }

    getProductNavigation(animationStatus)
    {
        if (animationStatus === 0) {
            switch (this.state.direction) {
                default:
                case 0:
                    return "";
                case 1:
                    return "bounce-left-out";
                case - 1:
                    return "bounce-right-out";
            }
        }
        if (animationStatus === 1) {
            switch (this.state.direction) {
                default:
                case 0:
                    return "";
                case 1:
                    return "bounce-left-in";
                case - 1:
                    return "bounce-right-in";
            }
        }
    }

    getImage(index)
    {
        if (this.props.images[index] === undefined) {
            return "";
        }
        return `data:image/png;base64, ${this.props.images[index]}`
    }

    render()
    {
        return (
            <div
                id="pop_up_main"
                style={{
                display: this.state.disabled
                    ? "none"
                    : "flex",
                width: "100%",
                height: "100vh",
                position: "absolute",
                justifyContent: "center",
                alignContent: "center",
                overflow: "hidden"
            }}>
                <div
                    className={this.getPopUpState("fade-in", "fade-out", "")}
                    style={{
                    zIndex: 125,
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    position: "absolute",
                    justifyContent: "center",
                    overflow: "hidden",
                    // backgroundColor: this.getPopUpState("#000000C0", "#000000C0", "transparent"),
                    backgroundImage: `url("data:image/png;base64, ${this.props.darkBG}")`,
                    animationDuration: "0.8s",
                    WebkitAnimationDuration: "0.8s",
                    pointerEvents: this.getPopUpState("auto", "none", "none")
                }}/>
                <div
                    style={{
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    position: "absolute",
                    justifyContent: "center",
                    alignContent: "center"
                }}>
                    <Grid
                        container
                        direction="row"
                        style={{
                        width: "100vw",
                        display: "contents"
                    }}>
                        <div
                            style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            visibility: this.getPopUpState("visible", "hidden", "hidden")
                        }}>
                            <img
                                id="poster"
                                onTouchStart={this.navigateToPreviousProduct}
                                onTouchEnd={absorbEvent}
                                src={this.props.leftButtonImage}
                                alt="Previous pop up"
                                style={{
                                zIndex: 200,
                                width: "12.5vh",
                                height: "12.5vh",
                                alignSelf: "center",
                                filter: this.productID === 0
                                    ? "grayscale(100%)"
                                    : ""
                            }}/>
                        </div>
                        <div
                            id={"all_products"}
                            className={this.getPopUpState("bounce-in", "bounce-out", "")}
                            style={{
                            zIndex: 150,
                            position: "relative",
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            width: "70vw"
                        }}>
                            <div
                                id={"product_a"}
                                style={{
                                zIndex: 150,
                                position: "absolute",
                                top: 0,
                                display: "flex",
                                alignContent: "center",
                                height: "100vh",
                                visibility: this.state.direction === 0
                                    ? "hidden"
                                    : "visible"
                            }}>
                                <img
                                    ref={this.imageA}
                                    key={`back_` + this.productID}
                                    className={this.getProductNavigation(0)}
                                    src={this.getImage(this.state.productIDA)}
                                    style={{
                                    maxHeight: "70vh",
                                    maxWidth: "70vw",
                                    alignSelf: "center",
                                    justifySelf: "center"
                                }}
                                    alt="Pop Up"></img>
                            </div>
                            <div
                                id={"product_controller"}
                                style={{
                                zIndex: 155,
                                position: "absolute",
                                top: 0,
                                display: "flex",
                                alignContent: "center",
                                height: "100vh"
                            }}>
                                <img
                                    ref={this.imageB}
                                    key={`front_` + this.productID}
                                    className={this.getProductNavigation(1)}
                                    id={"product_pop_up_main"}
                                    src={this.getImage(this.state.productIDB)}
                                    style={{
                                    maxHeight: "75vh",
                                    maxWidth: "70vw",
                                    alignSelf: "center",
                                    justifySelf: "center",
                                    visibility: this.getPopUpState("visible", "visible", "hidden")
                                }}
                                    alt="Pop Up"></img>
                            </div>
                        </div>
                        <div
                            style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            visibility: this.getPopUpState("visible", "hidden", "hidden")
                        }}>
                            <img
                                id="poster"
                                onTouchStart={this.navigateToNextProduct}
                                onTouchEnd={absorbEvent}
                                src={this.props.rightButtonImage}
                                alt="Next pop up"
                                style={{
                                zIndex: 200,
                                width: "12.5vh",
                                height: "12.5vh",
                                alignSelf: "center",
                                filter: this.productID + 1 >= this.props.images.length
                                    ? "grayscale(100%)"
                                    : ""
                            }}/>
                        </div>
                    </Grid>
                </div>
                <Button
                    disableRipple={true}
                    disableFocusRipple={true}
                    disableTouchRipple={true}
                    disableElevation={true}
                    onTouchStart={this.disable}
                    style={{
                    zIndex: 200,
                    backgroundColor: "transparent",
                    height: "15vh",
                    width: "15vh",
                    position: "absolute",
                    right: "5vh",
                    top: "5vh",
                    visibility: this.getPopUpState("visible", "hidden", "hidden")
                }}>
                    <img
                        src={this.props.closeButtonImage}
                        alt="Close pop up"
                        style={{
                        height: "12.5vh",
                        width: "12.5vh"
                    }}/>
                </Button>
            </div>
        );
    }
}

PopUp.propTypes = {
    images: PropTypes.array,
    leftButtonImage: PropTypes.string,
    rightButtonImage: PropTypes.string,
    closeButtonImage: PropTypes.string,
    closePopUpFunc: PropTypes.func,
    removePopUpFunc: PropTypes.func
};

PopUp.defaultProps = {
    images: [""],
    leftButtonImage: "",
    rightButtonImage: "",
    closeButtonImage: "",
    closePopUpFunc: function () {
        console.log("closePopUpFunc");
    },
    removePopUpFunc: function () {
        console.log("removePopUpFunc");
    }
};

export default PopUp;